<template lang="pug">
  //- TODO [次期]タブレット対応（touch系イベント）
  tbody.bcard-list-sortable(
      @mousedown="onMousedown"
      @mouseup="onMouseUp"
      @mousemove="onMouseMove"
      @touchstart="onMousedown"
      @touchend="onMouseUp"
      @touch="onMouseMove"
      :class="{enabled: enabled, dragging: isSortDragging}")
    slot
    //- table-borderedに影響を与えないように、最後尾に配置する
    tr.draggable-ghost(v-show="isSortDragging", ref="draggableGhost")
</template>

<script>
// AppListSortableNavとセットで使います
import RepositoryFactory from '@/repositories/RepositoryFactory'
export default {
  name: 'AppListSortable',
  props: {
    value: {type: Array, required: true}, // list
    /**
     * RepositoryFactory.getに使う名前
     */
    repo: {type: String, required: true},
    params: {type: Array, required: false, default: null},
    enabled: {type: Boolean, required: false, default: true}, // 有効無効の切り替え用
    // ソート完了時の付帯処理
    onComplete: {
      type: Function,
      required: false,
      default: function () {}
    }
  },
  data: function () {
    return {
      isMouseDown: false,
      isSortStarted: false,
      sortStartedY: null,
      isSortDragging: false,
      sortStartedItem: null,
      target: '',
      direction: ''
    }
  },
  watch: {
    '$store.state.base.isListSortMode': function (newMode, oldMode) {
      if (newMode === oldMode) {
        return
      }
      if (newMode) {
        this._startSort()
        // 表示順変更モードのときはボタンを押した時点でdrag中になる
        this.isSortDragging = true
      }
      else {
        this._cancelSort()
      }
    }
  },
  created: function () {
    // ページ替えで再ロードされた場合
    if (this.$store.getState('isListSortMode')) {
      this.isMouseDown = false
      this.isSortStarted = true
      this.isSortDragging = true
    }
    document.addEventListener('mouseup', this.onWindowMouseUp)
  },
  destroyed: function () {
    document.removeEventListener('mouseup', this.onWindowMouseUp)
  },
  methods: {
    /**
     * 表示順変更リクエスト送信
     */
    sendListSortRequest: function (isConfirmed) {
      // TIPS 移動前後の場所が同じだった場合には呼ばれない

      // 確認ダイアログ
      if (!isConfirmed) {
        this.$parent.$refs.sortableNav.isModalConfOpen = true
        return
      }

      // API実行
      const vm = this

      let data = {
        id: this.$parent.checkedIds,
        direction: this.direction,
        target: this.target
      }
      // 追加パラメータがあればリクエストに入れる
      if (this.params !== null) {
        for (let i = 0; i < this.params.length; i++) {
          data[Object.keys(this.params[i])[0]] = Object.values(this.params[i])[0]
        }
      }

      RepositoryFactory.get(this.repo).sort(data)
        .then(function (response) {
          vm.onComplete()
          if (!vm.isApiSuccess(response)) return
          vm.setSuccessMessage('表示順を変更しました。')
        })
        // エラー時処理
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm._finishSort()
          vm._finishSortMode()
          // 一覧の表示を最新or元に戻す
          vm.$parent.getList({page: vm.$parent.pagination.current_page})
          vm.$parent.errors = vm.errors
          vm.$parent.successes = vm.successes
        })
    },
    /**
     * マウスダウンイベント
     * 移動を開始する
     */
    onMousedown: function (e) {
      if (!this.enabled) {
        return
      }
      this.isMouseDown = true
      // 移動開始後は何もしない
      if (this.isSortStarted) {
        return
      }
      // チェックボックス、リンク、ボタン以外をhandleとする
      const target = e.target
      const targetTagName = target.tagName.toLowerCase()
      if (targetTagName === 'input' || targetTagName === 'a' || targetTagName === 'button') {
        return
      }
      // テキストなどが選択されないようにする
      e.preventDefault()
      // 動かそうとしているitemを特定する
      const elItem = target.closest('tr')
      // indexにdraggableGhostは含まれないので（最後尾に置いているから）1は引かなくていい
      const targetIndex = Array.prototype.indexOf.call(elItem.parentNode.childNodes, elItem)
      this.sortStartedItem = this.value[targetIndex]
      if (!this.sortStartedItem) {
        return
      }

      this._startSort(e)
    },
    /**
     * 移動を開始する
     */
    _startSort: function (e) {
      this.isSortStarted = true
      this.sortStartedY = e ? e.y : null
    },
    /**
     * 移動中イベント（DnDと表示順変更モードどちらでもつかう）
     */
    onMouseMove: function (e) {
      if (!this.enabled) {
        return
      }
      // 移動開始前は何もしない
      if (!this.isSortStarted) {
        return
      }
      // DnDの初回設定
      if (!this.isSortDragging && !this.$store.getState('isListSortMode')) {
        // 10px以内のマウス移動では起動しない
        if (this.sortStartedY && Math.abs(this.sortStartedY - e.y) < 10) {
          return
        }
        // 動かしているアイテムにチェックが付いていなければそれにチェックをつけて1件だけ動かす
        if (!this.$parent.isChecked(this.sortStartedItem.id)) {
          this.$parent.checkAll(false)
          this.$parent.checkItem(this.sortStartedItem.id, true)
        }
        // それ以外はチェックが付いている1件以上のアイテムを動かす
      }
      this.isSortDragging = true

      // 移動用のghost（黒いバー）を表示する
      this._moveGhost(e)
    },
    /**
     * 移動用のghost（黒いバー）を表示する
     */
    _moveGhost: function (e) {
      const draggableGhost = this.$refs.draggableGhost
      // DOM更新待ち
      if (!draggableGhost) {
        return
      }
      const elParent = draggableGhost.parentNode
      const elCur = e.target.closest('tr')
      const curRect = elCur && elCur.getBoundingClientRect()

      // マウスが載っている要素の前に移動
      if (e.clientY < (curRect.top + curRect.height / 2)) {
        elParent.insertBefore(draggableGhost, elCur)
      }
      // マウスが載っている要素の次に移動
      else if (e.clientY > curRect.top + curRect.height / 2) {
        elParent.insertBefore(draggableGhost, elCur.nextSibling)
      }
    },
    /**
     * マウスアップイベント（一覧内）
     * 表示順変更モードでは一覧内のみ処理を行う
     */
    onMouseUp: function (e) {
      if (!this.enabled) {
        return
      }
      this.isMouseDown = false
      this._execSort()
    },
    /**
     * マウスアップイベント（一覧外）
     * 表示順変更モードでは一覧外では処理を行わない
     */
    onWindowMouseUp: function (e) {
      if (!this.isMouseDown) {
        return
      }
      this.isMouseDown = false
      this._execSort()
    },
    /**
     * 移動をキャンセルする
     */
    _cancelSort: function () {
      this.isSortStarted = false
      this.isSortDragging = false
      this._finishSort()
      this._finishSortMode()
    },
    /**
     * 移動を終了する
     */
    _finishSort: function () {
      // draggableGhostを最後尾に移動する
      const draggableGhost = this.$refs.draggableGhost
      const elParent = draggableGhost.parentNode
      elParent.appendChild(draggableGhost)
    },
    /**
     * 表示順変更モードを終了する
     */
    _finishSortMode: function () {
      this.$store.commit('toggleListSortMode', false)
    },
    /**
     * 移動を実行する
     */
    _execSort: function () {
      // 動かさずに単なるクリックで終了する場合は含まない
      if (!this.$store.getState('isListSortMode')) {
        this.isSortStarted = false
      }

      // 移動開始していたら、移動終了する
      if (!this.isSortDragging) {
        return
      }
      this.isSortDragging = false

      const draggableGhost = this.$refs.draggableGhost
      const elPrev = draggableGhost.previousSibling
      const elTarget = elPrev || draggableGhost.nextSibling
      const elParent = elTarget.parentNode

      // パラメータ direction
      this.direction = elPrev ? 'after' : 'before'

      // パラメータ target
      let targetIndex = Array.prototype.indexOf.call(elParent.childNodes, elTarget)
      // before時はdraggableGhostがindexに含まれるので除外
      if (this.direction === 'before') {
        targetIndex -= 1
      }
      this.target = this.value[targetIndex].id

      this.sendListSortRequest(false)

      this._finishSort()
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-list-sortable.enabled tr {
  cursor: move;
}
// 移動中はtrに縞々の装飾をしない
.bcard-list-sortable.dragging tr {
  background: #fff;
}

// アイテムを動かしているときにつくスタイル
.draggable-ghost {
  height: 0;
  &:before {
    content: '';
    position: absolute;
    border: 6px solid transparent;
    border-left-color: #000;
    margin-top: -5px;
    margin-left: -5px;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/AppListSortable.vue